import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'Core/components';
import POAddEdit from './pomasters-add-edit';
import { MODAL_TYPES } from '../components/app-modals';
import { closeModal } from 'Core/redux/main/slice';

const { PO_ADD_EDIT } = MODAL_TYPES;

const POModals = () => {
  const dispatch = useDispatch();
  const showModal = useSelector(
    state => state.main?.modals?.some(modal => modal.id === PO_ADD_EDIT)
  );
  const modalData = useSelector(state => state.po?.selectedPO);

  return (
    <POAddEdit
      showModal={showModal}
      modalData={modalData}
      onCloseModal={() => dispatch(closeModal())}
    />
  );
};

const POImportModal = ({ showModal, onCloseModal }) => {
  return (
    <Modal show={showModal} onHide={onCloseModal} title="Import PO">
      <div className="p-3">
        <p>PO Import functionality will be implemented here.</p>
      </div>
    </Modal>
  );
};

POImportModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default POModals;
